import BMOGIFItem from './bmo-gif/bmo-gif-item';
import ProposalItem from './proposal-item';
import RiskProfileItem from './risk-profile-item';

export enum ORIENTATION {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

export type Proposal = {
  items: ProposalItem[];
  riskProfile?: RiskProfileItem;
  providedBy?: string;
  showBaseCurrencies?: boolean;
  gifItems?: BMOGIFItem[];
  hideBaseGifScenarios?: boolean;
};
